export const projectsData = [
  {
    id: 1,
    image: "/assets/chats.png",
    title: "Automate Chats",
    link: "https://automatechats.com/",
    category: "web",
  },
  {
    id: 2,
    image: "/assets/crm.png",
    title: "Automate CRM",
    link: "https://crmv2.automatebusiness.com/",
    category: "web",
  },
  {
    id: 3,
    image: "/assets/automate-forms.png",
    title: "Automate Forms (AI)",
    link: "https://automateforms.ai/",
    category: "web",
  },
  {
    id: 4,
    image: "/assets/Snapcover.png",
    title: "Snap Cover",
    link: "https://snap-cover.vercel.app/",
    category: "web",
  },
  {
    id: 5,
    image: "/assets/Visionmed.png",
    title: "Vision Med",
    link: "https://vision-med.vercel.app/",
    category: "web",
  },
  {
    id: 6,
    image: "/assets/rickmorty.png",
    title: "Rick & Morty task",
    link: "https://rick-and-morty-rho-wheat.vercel.app/",
    category: "web",
  },
  {
    id: 7,
    image: "/assets/Nablasol.png",
    title: "Nablasol task",
    link: "https://nablasol-tasks.vercel.app/",
    category: "design",
  },
  {
    id: 8,
    image: "/assets/Work1.webp",
    title: "Mini Portfolio",
    link: "https://card-its21yash.vercel.app/",
    category: "web",
  },
  {
    id: 9,
    image: "/assets/oknoted.webp",
    title: "Ok noted",
    link: "https://oknoted.netlify.app/",
    category: "web",
  },
  {
    id: 10,
    image: "/assets/Work3.webp",
    title: "Travel App",
    link: "https://travelappnext.netlify.app/",
    category: "design",
  },
  {
    id: 11,
    image: "/assets/Work5.webp",
    title: "Movie App",
    link: "https://its21yash.github.io/movie-app/",
    category: "web",
  },
  {
    id: 12,
    image: "/assets/Work6.webp",
    title: "Weather App",
    link: "https://applocal-weather.netlify.app/",
    category: "web",
  },
  {
    id: 13,
    image: "/assets/Work7.webp",
    title: "Tax Calculator",
    link: "https://fyle-taxcalci.netlify.app/",
    category: "web",
  },
  {
    id: 14,
    image: "/assets/Work8.webp",
    title: "Ottermap WebApp",
    link: "https://ottermap-assign.netlify.app/",
    category: "web",
  },
  {
    id: 15,
    image: "/assets/Work9.webp",
    title: "NetArt Assign",
    link: "https://netart-yash.netlify.app/",
    category: "design",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "design",
  },
];
